import { CartItems } from "~/components/cart"
import { trapFocus, removeTrapFocus } from "~/core/global"
class CartDrawer extends HTMLElement {
  constructor() {
    super()

    this.overlay = this.querySelector('#CartDrawer-Overlay')
    this.main = document.querySelector('#MainContent')

    this.setHeaderCartIconAccessibility()
    this.overlay.addEventListener('click', this.close.bind(this))
    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close())
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble')
    cartLink.setAttribute('role', 'button')
    cartLink.setAttribute('aria-haspopup', 'dialog')
    cartLink.addEventListener('click', () => {
      this.open(cartLink)
    })
    cartLink.addEventListener('keydown', () => {
      if (event.code.toUpperCase() === 'SPACE') {
        this.open(cartLink)
      }
    })
  }

  customCheckoutButtons() {
    const applePay = document.querySelector('[data-testid="ApplePay-button"]')
    if (applePay) {
      const checkoutButtonsWrapper = document.querySelector('.additional-checkout-buttons')
      const applePayParent = applePay.parentNode
      checkoutButtonsWrapper.classList.add('visible')
      applePayParent.classList.add('visible')
    }
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy)
    setTimeout(() => {
      this.classList.add('is-active', 'is-visible')
      document.body.classList.add('drawer-open')
    })

    this.addEventListener('transitionend', () => {
      const containerToTrapFocusOn = this.classList.contains('is-empty') ? this.querySelector('.drawer__inner-empty') : document.getElementById('CartDrawer')
      const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close')
      trapFocus(containerToTrapFocusOn, focusElement)
      this.customCheckoutButtons()
    }, { once: true })

    this.main.classList.add('focus-none', 'open-drawer')
    document.body.classList.add('overflow-hidden')
  }

  close() {
    this.classList.remove('is-active', 'is-visible')
    this.main.classList.remove('focus-none', 'open-drawer')
    if (document.body.classList.contains('drawer-open')) {
      document.body.classList.remove('drawer-open')
    }
    removeTrapFocus(this.activeElement)
    document.body.classList.remove('overflow-hidden')
    document.body.classList.remove('scrolled_down')
    document.body.classList.add('scrolled_up')
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') && this.querySelector('.drawer__inner').classList.remove('is-empty')
    if (parsedState.id){
      this.productId = parsedState.id
    }
    this.getSectionsToRender().forEach((section => {
      const sectionElement = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id)
      sectionElement.innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector)
    }))

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this))
      this.open()
      console.log('auto close')
    })
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ]
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector)
  }

  setActiveElement(element) {
    this.activeElement = element
  }
}

customElements.define('cart-drawer', CartDrawer)

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ]
  }
}

customElements.define('cart-drawer-items', CartDrawerItems)
